(function () {
  if (window.__ND_UPLOAD_EMAIL_BRIDGE__) return;
  window.__ND_UPLOAD_EMAIL_BRIDGE__ = true;

  const API_URL = 'https://nd-onedrive-uploader-2.vercel.app/apps/nd-upload/upload-and-email';
  const REPLY_TO = 'quoteneumadoors@gmail.com'; // ← 這裡填你們真的在用的 Gmail

  function keyOf(payload) {
    return [
      String(payload.serial || '').trim().toUpperCase(),
      String(payload.customerEmail || '').trim().toLowerCase()
    ].join('|');
  }

  window.ND_UPLOAD_EMAIL_BRIDGE = {
    _map: {},

    push(partial) {
      const k = keyOf(partial);
      if (!k || k === '|') {
        console.warn('[ND bridge] missing key parts', partial);
        return;
      }

      const prev = this._map[k] || {};
      const next = { ...prev, ...partial };
      this._map[k] = next;

      console.log('[ND bridge] stored', k, next);

      if (
        next.pdfBlob &&
        next.xlsxBlob &&
        next.pdfName &&
        next.xlsxName &&
        next.customerEmail &&
        next.serial &&
        !next._sending
      ) {
        next._sending = true;
        this._map[k] = next;
        this.send(next).catch(err => {
          console.error('[ND bridge] send failed', err);
          next._sending = false;
          this._map[k] = next;
        });
      }
    },

    async send(data) {
      const fd = new FormData();
      fd.append('pdf', data.pdfBlob, data.pdfName);
      fd.append('xlsx', data.xlsxBlob, data.xlsxName);
      fd.append('pdf_name', data.pdfName);
      fd.append('xlsx_name', data.xlsxName);
      fd.append('subpath', data.subpath || '');
      fd.append('customer_email', data.customerEmail || '');
      fd.append('customer_name', data.customerName || '');
      fd.append('quotation_no', data.serial || '');
      if (data.replyTo || REPLY_TO) {
  fd.append('reply_to', data.replyTo || REPLY_TO);
}

      const r = await fetch(API_URL, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { Accept: 'application/json' },
        body: fd
      });

      let js = null;
      try { js = await r.json(); } catch {}

      if (!r.ok || !js?.ok) {
        throw new Error(js?.error || `HTTP ${r.status}`);
      }

      console.log('[ND bridge] upload+email ok', js);

      const k = keyOf(data);
      delete this._map[k];
      return js;
    }
  };
})();